<template>
    <form class="" @submit.prevent="submit">
        <!-- Form header -->
        <slot name="header"></slot>

        <el-error :error="error"></el-error>

        <!-- Form content -->
        <slot name="default"></slot>

        <!-- Submit handler -->
        <div v-if="!hasFooterSlot" class="d-flex mt-10">
            <button class="btn btn-primary" :disabled="loading" type="submit">
                {{submitLabel || $t('form.submit')}}
                <i-loader v-if="loading" class="i-15 ml-16 my-auto"></i-loader>
            </button>
        </div>
        <slot v-else name="footer"></slot>

    </form>
</template>

<script>
import { ElError } from '@/components/forms'

export default {
    inject: ['$validator'],

    name: 'el-form',

    components: { ElError },

    props: {

        loading: {
            type: [Boolean],
            default: false,
            required: false,
        },

        error: {
            default: false,
            required: false,
        },

        submitLabel: {
            type: String
        }
    },

    methods: {

        /*
        | Submit
        | ------------------
        | Submit the form using enter
        | and trigger the submit event
        */
        submit() {
            this.$emit('submit');
        },
    },

    computed: {
        hasFooterSlot() {
            return !!this.$slots.footer;
        },
    },
};
</script>
